import { KeyConstructor } from './keyConstructor';
const LEADERBOARD_KEY = 'leaderBoard';
const LEADERBOARD_WITH_SCORES_KEY = 'leaderboardWithScores';
const ACTIVITY_LOG_KEY = 'activityLog';
const ANALYTICS_KEY = 'analytics';
export const getLeaderboardKey = KeyConstructor(LEADERBOARD_KEY);
export const getLeaderboardWithScoresKey = KeyConstructor(LEADERBOARD_WITH_SCORES_KEY);
export const getActivityLogKey = KeyConstructor(ACTIVITY_LOG_KEY);
export const getAnalyticsKey = KeyConstructor(ANALYTICS_KEY);
//# sourceMappingURL=report.keys.js.map